/* ============================================================
   tcc-blog-cta.js — fires the GA4 `blog_cta_click` event for any a.blog-cta.
   Pushes to dataLayer (GTM) and calls gtag() if present. One delegated
   listener => exactly one event per click (no duplicate firing, QA §Analytics).
   No UTMs, no PII. Standard event (NOT a key event) per SoT §12.3.
   ============================================================ */
(function () {
  function payload(a) {
    return {
      event: 'blog_cta_click',
      article_path: a.getAttribute('data-article-path') || location.pathname,
      article_slug: a.getAttribute('data-article-slug') || '',
      article_title: a.getAttribute('data-article-title') || '',
      article_category: a.getAttribute('data-article-category') || '',
      cta_type: a.getAttribute('data-cta-type') || '',
      cta_position: a.getAttribute('data-cta-position') || '',
      destination: a.getAttribute('data-destination') || '',
      link_url: a.getAttribute('data-link-url') || a.getAttribute('href') || '',
      link_text: (a.textContent || '').trim(),
      offer: a.getAttribute('data-offer') || 'none'
    };
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a.blog-cta') : null;
    if (!a) return;
    var data = payload(a);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'blog_cta_click', data);
    }
  }, true);
})();
